import debounce from 'lodash/debounce';

import {
	prepareIncomingData,
	setContent
} from '../_utils';

export default class LiveSearch {
	constructor ($root, options = {}) {
		let defaults = {
			$root: $root,
			$form: $root.find('[data-live-search="form"]'),
			$input: $root.find('[data-live-search="input"]'),
			$suggestion: $root.find('[data-live-search="suggestion"]'),
			$sContent: $root.find('[data-live-search="suggestion-content"]'),
			$sSection: $root.find('[data-live-search="suggestion-section"]').detach(),
			$allResults: $root.find('[data-live-search="all-results"]'),
			$allResultsLink: $root.find('[data-live-search="all-results-link"]'),
			$city: $root.find('[data-live-search="city"]'),
			$cityLink: $root.find('[data-live-search="city-link"]'),
			css: {
				hasResult: 'has-result',
				hasSuccess: 'has-success',
				hasError: 'has-error',
				shortQuery: 'short-query'
			},
			message: {
				zeroResults: $root.data('zero-results') || 'Нет результатов поиска'
			},
			minQueryLength: 3
		};
		window.liveSearchInstance = null;
		this.params = $.extend(true, {}, defaults, options);
		this.$document = $(document);
		this.$window = $(window);
		this.query = this.params.$input.val() || null;
		this.lastRenderHasSuccess = false;
		this.init();
	}

	init () {
		this.addListeners();
	}

	addListeners () {
		let _self = this;
		let route = window.projectConfig.route.ajax.livesearch;

		this.params.$input.on('input', debounce((e) => {
			if (e.keyCode === 13) {
				this.params.$form.submit();
				return;
			}

			this.query = e.target.value.trim();

			if (this.query && this.query.length >= this.params.minQueryLength) {
				$.ajax({
					type: 'POST',
					url: route,
					data: {
						query: this.query
					}
				})
					.done((res) => {
						res = prepareIncomingData(res);
						_self.render(res)
							.then(() => {
								this.toggle('open');
							})
							.catch((err) => {
								this.toggle('error', err);
							});
					})
					.fail((err) => {
						console.warn('Ошибка загрузки данных', err);
					})
					.always(() => {});
			} else if (!this.query) {
				this.toggle('close');
			} else {
				this.toggle('short-query');
			}
		}, 300)).on('focus', () => {
			this.switchInstance();
			if (!this.query) {
				this.toggle('close');
			} else if (this.query && this.query.length >= this.params.minQueryLength && !this.lastRenderHasSuccess) {
				this.toggle('search');
			} else if (this.query && this.query.length >= this.params.minQueryLength && this.lastRenderHasSuccess) {
				this.toggle('open');
			} else {
				this.toggle('short-query');
			}
		});

		this.params.$form.on('reset', () => {
			this.query = null;
		});

		this.params.$form.on('submit', (e) => {
			if (this.query && this.query.length < this.params.minQueryLength) {
				e.preventDefault();
				this.toggle('short-query');
			}
		});

		this.params.$root.on('click.live-search.stopBubble', (e) => {
			e.stopPropagation();
		});

		this.$document.on('click.live-search.close click.toggle.close', () => {
			this.toggle('close');
		});

		$('[data-live-search="close"]').on('click', () => {
			this.$document.trigger('click.live-search.close');
		});

		this.$window.on('resize', debounce(() => {
			this.$document.trigger('click.live-search.close');
		}, 150));
	}

	toggle (action = null, err = null) {
		if (!action) {
			return;
		}

		let {
			hasResult,
			hasSuccess,
			hasError,
			shortQuery
		} = this.params.css;

		switch (action) {
			case 'short-query':
				this.params.$root.removeClass(`${hasResult} ${hasSuccess} ${hasError}`).addClass(shortQuery);
				break;
			case 'search':
				this.params.$input.trigger('input');
				break;
			case 'open':
				this.switchInstance();
				this.lastRenderHasSuccess = true;
				this.params.$root.removeClass(shortQuery).addClass(`${hasResult} ${hasSuccess}`);
				break;
			case 'close':
				this.params.$root.removeClass(`${hasResult} ${hasSuccess} ${hasError} ${shortQuery}`);
				break;
			case 'error':
				this.lastRenderHasSuccess = false;
				this.params.$root.removeClass(`${hasResult} ${hasSuccess} ${shortQuery}`).addClass(hasError);
				if (err) {
					console.warn(err);
				}
				break;
			default:
				break;
		}
	}

	switchInstance () {
		if (window.liveSearchInstance) {
			window.liveSearchInstance.toggle('close');
		}
		window.liveSearchInstance = this;
	}

	search () {
		this.params.$input.trigger('input');
	}

	render (data) {
		data = prepareIncomingData(data);

		return new Promise((resolve, reject) => {
			if (data instanceof Error) {
				reject(data);
			}

			/**
			 * Если передана кастомная функция для рендера результата поиска, то вызываем ее, привязываем к ней контекст и передаем в нее данные по запросу
			 * Иначе используем дефолтную функцию рендера
			 */
			if (this.params.renderFunc) {
				this.params.renderFunc.call(this, data);
			} else {
				let content = [];
				let template = this.params.$sSection[0].outerHTML;

				data.results.forEach((responseItem) => {
					content.push(setContent(template, responseItem));
				});

				if (content.length) {
					this.params.$sContent[0].innerHTML = content.join('');
				} else {
					this.params.$sContent[0].innerHTML = `
						<div class="site-search__suggestion-section">
							<div class="site-search__suggestion-title">${this.params.message.zeroResults}</div>
						</div>
					`;
				}

				if (data['results-city']) {
					this.params.$cityLink.attr('href', data['results-city'].link);
					this.params.$cityLink.html(data['results-city'].name);
					this.params.$city.removeClass('_hide');
				} else {
					this.params.$city.addClass('_hide');
				}

				if (data['all-results-link'] && data['all-results-text']) {
					this.params.$allResultsLink.attr('href', data['all-results-link']);
					this.params.$allResultsLink.html(data['all-results-text']);
					this.params.$allResults.removeClass('_hide');
				} else {
					this.params.$allResults.addClass('_hide');
					this.params.$allResultsLink.removeAttr('href');
				}
			}

			resolve();
		});
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_classes/LiveSearch.js